<template>
    <a href="#comments_wrapper" class="share_content comment_count gtm-trigger-element" :data-gtm-category="'article_page'" :data-gtm-label="'comment'" :data-gtm-value="''">
        <span class="count_text gtm-trigger-element" :data-gtm-category="'article_page'" :data-gtm-label="'comment'" :data-gtm-value="''">{{ commentNums }}</span>
    </a>
</template>

<script>
import { commentGet } from '@vuePath/api/article';
 export default {
    mounted() {
        this.getCommentList();
    },
    props: {
        nid: {
            type: String
        }
    },
    data() {
        return {
            commentNums: 0,
            currentID: 0,
            size: 3
        }
    },
    methods: {
        getCommentList() {
            return new Promise((resolve, reject) => {
                commentGet(this.nid, this.currentID, this.size)
                    .then(res => {

                        if ((res.data.code === '000') && (res.data.data.article_comment.length !== 0)) {
                            let data = res.data.data;
                            this.commentNums = data.total;
                        }

                        resolve(res);
                    })
                    .catch(function (err) {
                        reject(err);
                    });
            });
        },
    }
}
</script>